import { useCallback, useEffect, useState } from 'react'

/** Looping carousel index with autoplay that restarts its timer on every slide change. */
export function useCarousel(count: number, interval: number, paused: boolean) {
  const [index, setIndex] = useState(0)

  const go = useCallback((delta: number) => setIndex((i) => (i + delta + count) % count), [count])
  const goTo = useCallback((i: number) => setIndex(((i % count) + count) % count), [count])

  useEffect(() => {
    if (paused || count < 2) return
    const id = window.setTimeout(() => setIndex((i) => (i + 1) % count), interval)
    return () => window.clearTimeout(id)
  }, [index, paused, count, interval])

  /** Shortest signed distance from the active slide, e.g. -2..2 for five slides. */
  const offsetOf = useCallback(
    (i: number) => {
      let d = (i - index + count) % count
      if (d > count / 2) d -= count
      return d
    },
    [index, count],
  )

  return { index, go, goTo, offsetOf }
}
